import React from 'react'

const Video = ({ src, url = 'https://www.latercera.com' }) => {
  return (
    <div className="pb-4 video-container">
      <video className="video" autoPlay loop muted playsInline src={src} />
      <span className="font-sans text-sm ">
        Ver video completo en{' '}
        <a href={url} target="_blank" className="underline ">
          latercera.com
        </a>
      </span>
    </div>
  )
}

export default Video
